export const DEFAULT_CUSTOMIZATION = {
  primaryFont: null,
  secondaryFont: null,
  primaryColor: null,
  secondaryColor: null,
  tertiaryColor: null,
  brandColor: null,
  primaryBgColor: null,
  secondaryBgColor: null,
  primaryBorderColor: null,
  secondaryBorderColor: null,
  primaryBorderRadius: null,
  secondaryBorderRadius: null,
  tertiaryBorderRadius: null,
  showShippingEstimation: false,
  enableDefaultDone: false,
  enablePoweredBy: false,
  enableMagicNoSearch: false,
  tabTitle: null,
};

const BOOLEAN_KEYS = [
  "showShippingEstimation",
  "enableDefaultDone",
  "enablePoweredBy",
  "enableMagicNoSearch",
];

export const normalizeCustomization = (customization = {}) => {
  const merged = {
    ...DEFAULT_CUSTOMIZATION,
    ...(customization || {}),
  };

  BOOLEAN_KEYS.forEach((key) => {
    merged[key] = merged[key] == null ? false : Boolean(merged[key]);
  });

  Object.keys(DEFAULT_CUSTOMIZATION).forEach((key) => {
    if (BOOLEAN_KEYS.includes(key)) return;
    if (merged[key] === undefined || merged[key] === "") {
      merged[key] = null;
    }
  });

  return merged;
};

export const withCustomizationDefaults = (values = {}) => ({
  ...values,
  custom_swatch_hex: values.custom_swatch_hex || null,
  customization: normalizeCustomization(values.customization),
});
